import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { Theme } from '@mui/material/styles'

export const soldServiceStatusColor = (
  status: SOLD_SERVICE_STATUS,
  theme: Theme,
): string => {
  switch (status) {
    case SOLD_SERVICE_STATUS.Completed:
      return theme.palette.success.light
    case SOLD_SERVICE_STATUS.NotSent:
      return '#F44336'
    case SOLD_SERVICE_STATUS.Processing:
      return '#ed6c02'
    case SOLD_SERVICE_STATUS.Revise:
      return '#F44336'
    case SOLD_SERVICE_STATUS.Submitted:
      return '#2196F3'
    default:
      return theme.palette.common.black
  }
}
